define(['angular'], function(angular) {


    function OrderProvider() {
        var bdcUrl;

        /**
         * @param {String} url
         */
        this.setBDCUrl = function setBDCUrl(url) {
            bdcUrl = url;
        };

        this.$get = [
            '$http',
            function($http) {
                var self = {};

                /**
                 * Get orders
                 * @param {Object} opts
                 * @param {String} opts.offset
                 * @param {Array}  opts.rds
                 * @param {Array}  opts.drv
                 * @param {Array}  opts.telepro --> concatenated with rds filter to see who created the order
                 * @param {Array}  opts.cup --> concatenated with rds filter to see who created the order
                 * @param {Array}  opts.formerRDS --> concatenated with rds filter to see who created the order
                 * @param {Array}  opts.market
                 * @param {int}  opts.status
                 * @param {String} opts.network
                 * @param {String} opts.identifiant
                 * @param {String} opts.client
                 * @param {String} opts.dateStart
                 * @param {String} opts.dateEnd
                 * @param {String} opts.creationDateStart
                 * @param {String} opts.creationDateEnd
                 * @param {String} opts.signatureMonth
                 * @param {String} opts.installationMonth
                 * @param {String} opts.limit
                 * @param {int} opts.cancelled
                 * @param {int} opts.lost
                 * @param {int} opts.abandoned
                 * @param {int} opts.cpiNotCreated
                 * @param {int} opts.cpiReleased
                 * @param {int} opts.jdsInjected
                 * @param {int} opts.cmdeKey
                 * @param {int} opts.orderScenario
                 * @return {Promise}
                 */
                self.getOrders = function getOrders(opts) {
                    var baseUrl = bdcUrl + 'orders?limit=' + opts.limit + '&offset=' + opts.offset * opts.limit;

                    baseUrl +=
                        '&rds=[' + opts.rds.concat(opts.telepro, opts.cs, opts.cup, opts.formerRDS).join(',') + ']';
                    baseUrl += '&drv=[' + opts.drv.join(',') + ']';

                    if (opts.market && opts.market.length !== 0) {
                        baseUrl += '&marketType=[' + opts.market.join(',') + ']';
                    }

                    if (opts.status !== undefined && opts.status !== null) {
                        baseUrl += '&status=' + opts.status;
                    }

                    if (opts.network !== undefined && opts.network !== null) {
                        baseUrl += '&network=' + opts.network;
                    }

                    if (opts.identifiant !== undefined && opts.identifiant !== null) {
                        baseUrl += '&identifiant=' + opts.identifiant;
                    }

                    if (opts.client !== undefined && opts.client !== null) {
                        baseUrl += '&client=' + opts.client;
                    }

                    if (opts.dateStart !== undefined && opts.dateStart !== null) {
                        baseUrl += '&dateStart=' + opts.dateStart;
                    }

                    if (opts.dateEnd !== undefined && opts.dateEnd !== null) {
                        baseUrl += '&dateEnd=' + opts.dateEnd;
                    }

                    if (opts.creationDateStart !== undefined && opts.creationDateStart !== null) {
                        baseUrl += '&creationDateStart=' + opts.creationDateStart;
                    }

                    if (opts.creationDateEnd !== undefined && opts.creationDateEnd !== null) {
                        baseUrl += '&creationDateEnd=' + opts.creationDateEnd;
                    }

                    if (opts.signatureMonth && opts.signatureMonth[0] !== undefined && opts.signatureMonth[0] !== null) {
                        baseUrl += '&signatureMonthStart=' + opts.signatureMonth[0];
                        if (opts.signatureMonth[1] !== null) {
                            baseUrl += '&signatureMonthEnd=' + opts.signatureMonth[1];
                        }
                    }

                    if (opts.installationMonth &&opts.installationMonth[0] !== undefined && opts.installationMonth[0] !== null) {
                        baseUrl += '&installationMonthStart=' + opts.installationMonth[0];
                        if (opts.installationMonth[1] !== null) {
                            baseUrl += '&installationMonthEnd=' + opts.installationMonth[1];
                        }
                    }

                    if (opts.cancelled !== undefined && opts.cancelled !== null) {
                        baseUrl += '&cancelled=' + opts.cancelled;
                    }

                    if (opts.lost !== undefined && opts.lost !== null) {
                        baseUrl += '&lost=' + opts.lost;
                    }

                    if (opts.abandoned !== undefined && opts.abandoned !== null) {
                        baseUrl += '&abandoned=' + opts.abandoned;
                    }

                    if (opts.cpiNotCreated !== undefined && opts.cpiNotCreated !== null) {
                        baseUrl += '&cpiNotCreated=' + opts.cpiNotCreated;
                    }

                    if (opts.cpiReleased !== undefined && opts.cpiReleased !== null) {
                        baseUrl += '&cpiReleased=' + opts.cpiReleased;
                    }

                    if (opts.jdsInjected !== undefined && opts.jdsInjected !== null) {
                        baseUrl += '&jdsInjected=' + opts.jdsInjected;
                    }

                    if (opts.cmdeKey !== undefined && opts.cmdeKey !== null) {
                        baseUrl += '&cmdeKey=' + opts.cmdeKey;
                    }

                    if (opts.orderScenario && opts.orderScenario.length !== 0) {
                        baseUrl += '&orderScenario=[' + opts.orderScenario.join(',') + ']';
                    }

                    if (opts.offerType && opts.offerType !== undefined && opts.offerType !== null) {
                        baseUrl += '&offerType=' + opts.offerType;
                    }

                    if (opts.isExportJdsTrad && opts.isExportJdsTrad !== undefined && opts.isExportJdsTrad !== null) {
                        baseUrl += '&isExportJdsTrad=' + opts.isExportJdsTrad;
                    }

                    if (opts.businessId && opts.businessId !== null) {
                        baseUrl += '&businessId=' + opts.businessId;
                    }

                    return $http.get(baseUrl).then(function(res) {
                        return res.data;
                    });
                };

                /**
                 * Get order form
                 * @param  {String} date : YYYY-MM-DD
                 * @return {Promise}
                 */
                self.getOrderForm = function getOrderForm(date) {
                    return $http.get(bdcUrl + 'order/form/' + date).then(function(res) {
                        return res.data;
                    });
                };

                /**
                 * Save order to the webservice
                 * @param  {Boolean} isGoodwillGestures
                 * @param  {Object}  order
                 * @return {Promise}
                 */
                self.saveOrder = function saveOrder(isGoodwillGestures, order) {
                    if (!isGoodwillGestures) {
                        order.goodwillGestures = null;
                    }
                    // Update
                    if (order.id) {
                        return $http.put(bdcUrl + 'order/' + order.id, order).then(function(res) {
                            return { order: res.data, dateCreated: order.dateCreated };
                        });
                    }
                    // Create
                    return $http.post(bdcUrl + 'order', order).then(function(res) {
                        return { order: res.data, dateCreated: order.dateCreated };
                    });
                };

                /**
                 * Delete an order
                 * @param  {int} id
                 * @return {Promise}
                 */
                self.deleteOrder = function deleteOrder(id) {
                    return $http.delete(bdcUrl + 'order/' + id).then(function(res) {
                        return { info: res.data, id: id };
                    });
                };

                /**
                 * Sign an order
                 * @param  {int} id
                 * @param  {Object} order
                 * @return {Promise}
                 */
                self.signOrder = function signOrder(id, order) {
                    return $http.post(bdcUrl + 'order/' + id + '/sign', order).then(function(res) {
                        return { info: res.data, order: order };
                    });
                };

                self.getEsignUrl = (registration) => {
                    return $http.get(bdcUrl + 'order/esign/' + registration).then((res) => {
                        return res.data;
                    }).catch(err => {
                        throw err;
                    });
                }

                self.getDocuments = (registration) => {
                    return $http.get(bdcUrl + 'order/esign/documents/' + registration).then((res) => {
                        return res.data;
                    }).catch(err => {
                        throw err;
                    });
                }

                /**
                 * Change le client d'une commande
                 * @param  {int} orderId
                 * @param  {Object} client
                 * @return {Promise}
                 */
                self.changeClient = function changeClient(orderId, client) {
                    return $http.put(bdcUrl + 'order/' + orderId + '/changeClient', client).then(function(res) {
                        return { info: res.data };
                    });
                };


                /**
                 * Save a CPI for the corresponding order
                 * @param  {int} orderId
                 * @param  {Object} cpi
                 * @return {Promise}
                 */
                self.saveCPI = function saveCPI(orderId, cpi) {
                    return $http.post(bdcUrl + 'order/' + orderId + '/cpi', cpi).then(function(res) {
                        return res.data;
                    });
                };

                /**
                 * Publish a CPI
                 * @param  {int} orderId
                 * @return {Promise}
                 */
                self.publishCPI = function publishCPI(orderId) {
                    return $http.post(bdcUrl + 'order/' + orderId + '/cpi/publish').then(function(res) {
                        return res.data;
                    });
                };

                /**
                 * Delete a CPI
                 * @param  {int} orderId
                 * @return {Promise}
                 */
                self.deleteCPI = function deleteCPI(orderId) {
                    return $http.delete(bdcUrl + 'order/' + orderId + '/cpi').then(function(res) {
                        return res.data;
                    });
                };

                /**
                 * Cancel an order
                 * @param  {int} orderId
                 * @return {Promise}
                 */
                self.cancel = function cancel(orderId) {
                    return $http.post(bdcUrl + 'order/' + orderId + '/cancel').then(function(res) {
                        return res.data;
                    });
                };

                /**
                 * Replace an order
                 * @param  {Object} order
                 * @return {Promise}
                 */
                self.replace = function replace(order) {
                    return $http.post(bdcUrl + 'order/' + order.id + '/replace', order).then(function(res) {
                        return res.data;
                    });
                };

                /**
                 * Rollback the creation date of an order.
                 * Sends a POST request to the backend to rollback the `dateCreated` field of the specified order.
                 *
                 * @function rollbackDateCreated
                 * @param {Object} order - The order object containing the `id` and other relevant data.
                 * @param {number} order.id - The unique identifier of the order.
                 * @return {Promise} - A promise that resolves with the response data from the server.
                 */
                self.rollbackDateCreated = function(order){
                    return $http.post(bdcUrl + 'order/' + order.id + '/rollbackDateCreated', order).then(function(res) {
                        return res.data;
                    });
                }

                /**
                 * Duplicate an order
                 * @param  {Object} order
                 * @return {Promise}
                 */
                self.duplicate = function duplicate(order) {
                    return $http.post(bdcUrl + 'order/' + order.id + '/duplicate', order).then(function(res) {
                        return res.data;
                    });
                };

                /**
                 * Save cmde keys
                 * @param  {Object} order
                 * @return {Promise}
                 */
                self.saveCmdeKeys = function saveCmdeKeys(order) {
                    var data = {
                        cmdeKey: order.cmdeKey,
                        cmdeComment: order.cmdeComment
                    };
                    return $http.put(bdcUrl + 'order/' + order.id + '/cmde', data).then(function(res) {
                        return res.data;
                    });
                };

                /**
                 * Update order's jds injected attribute
                 * @method setJdsInjected
                 * @param  {Object} order
                 * @param  {Boolean} value
                 * @return {Promise}
                 */
                self.setJdsInjected = function setJdsInjected(order, value) {
                    return $http.post(bdcUrl + 'order/' + order.id + '/jdsinjected', value).then(function(res) {
                        return res.data;
                    });
                };

                /**
                 * Lose an order
                 * @method lose
                 * @param  {Boolean} value
                 * @param  {Object} order
                 * @return {Promise}
                 */
                self.lose = function lose(id, order) {
                    return $http.post(bdcUrl + 'order/' + id + '/lose', order).then(function(res) {
                        return res.data;
                    });
                };

                /**
                 * Abandoned an order
                 * @method lose
                 * @param  {Boolean} value
                 * @param  {Object} order
                 * @return {Promise}
                 */
                self.abandoned = function (id, order) {
                    return $http.post(bdcUrl + 'order/' + id + '/abandoned', order).then(function(res) {
                        return res.data;
                    });
                };

                /**
                 * Set an order ready for integration in X3
                 * @method setReadyForX3Integration
                 * @param  {Boolean} value
                 * @param  {Object} order
                 * @return {Promise}
                 */
                self.setReadyForX3Integration = function setReadyForX3Integration(id, order) {
                    return $http.post(bdcUrl + 'order/' + id + '/readyforx3', order).then(function(res) {
                        return res.data;
                    });
                };

                /**
                 * Save real date signature
                 * @method setReadyForX3Integration
                 * @param  {Boolean} value
                 * @param  {Object} order
                 * @return {Promise}
                 */
                self.setRealDateSignature = function (id, order) {
                    return $http.post(bdcUrl + 'order/' + id + '/realSign', order).then(function(res) {
                        return res.data;
                    });
                };

                /**
                 * Envoi les données de la commande pour la signature electronique
                 * @method electronicSignature
                 * @param id
                 * @param idClient
                 * @param  {Object} order
                 * @param  {String} dateSendElectronicSignature
                 * @param  {boolean} joinRac
                 * @return {Promise}
                 */
                self.electronicSignature = function(id, idClient, order, dateSendElectronicSignature, joinRac, liz) {
                    return $http
                        .post(bdcUrl + 'order/' + id + '/electronic-signature', {
                            idClient,
                            order,
                            dateSendElectronicSignature,
                            joinRac,
                            liz
                        })
                        .then(function(res) {
                            return res.data;
                        });
                };

                /**
                 * Save the reference of the order returned by the signature API
                 * @param  {Object} order
                 * @return {Promise}
                 */
                self.saveSignApiReference = function saveSignApiReference(order) {
                    var data = {};

                    // return $http.put(bdcUrl + 'order/' + order.id + '/signapireference', data).then(function (res) {
                    //   return res.data;
                    // });
                    return new Promise(function(resolve, reject) {
                        resolve('todo');
                    });
                };

                self.getJdpOrders = function (startDate, endDate) {
                    return $http.get(`${bdcUrl}order/sponsors?start=${startDate}&end=${endDate}`, {
                        responseType: 'blob',
                        headers: { Accept: 'text/csv' }
                    }).then(function(res) {
                        return res;
                    });
                }

                self.saveSponsor = (data) => {
                    return $http.post(bdcUrl + 'order/' + data.orderId + '/sponsor', data).then(function(res) {
                        return res.data;
                    });
                }

                return self;
            }
        ];
    }

    angular.module('app.bdc.list.orderProvider', []).provider('order', OrderProvider);
});
